import { builder } from './builder';
import { buttons } from './buttons';
import { checkbox } from './checkbox';
import { dropdown } from './dropdown';
import { focusOutline } from './focusOutline';
import { fonts } from './fonts';
import { fontSizes } from './fontSizes';
import { fontWeights } from './fontWeights';
import { getBreakpoints } from './getBreakpoints';
import { getColors } from './getColors';
import { getThemeVariables } from './getThemeVariables';
import { grid } from './grid';
import { input } from './input';
import { label } from './label';
import { lineHeights } from './lineHeights';
import { space } from './space';
import { tags } from './tags';
import { zIndices } from './zIndices';
export const createTheme = ({ builderCustomBreakpoints, builderDisableStyledSystemCache = false, customColors = {}, customThemeVariables = {}, themeName, } = { customColors: {}, customThemeVariables: {}, themeName: 'bo' }) => {
    const initialTheme = {
        breakpoints: getBreakpoints(builderCustomBreakpoints),
        builder,
        colors: getColors(customColors),
        disableStyledSystemCache: builderDisableStyledSystemCache,
        dropdown,
        fontSizes,
        fontWeights,
        grid,
        lineHeights,
        space,
        themeName,
        themeVariables: getThemeVariables(customThemeVariables),
        zIndices,
    };
    return Object.assign(Object.assign({}, initialTheme), { buttons: buttons(initialTheme), checkbox: checkbox(initialTheme), focusOutline: focusOutline(initialTheme), fonts: fonts(initialTheme), input: input(initialTheme), label: label(initialTheme), tags: tags(initialTheme) });
};
export const defaultTheme = (() => createTheme())();
//# sourceMappingURL=index.js.map